export class Address {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    postcode: string;
  }

